//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import PublicService from '@/service/public'

import BuildingService from '@/service/building'
import BusinessBuildingService from '@/service/business_building'


import ShareOptions from '@/components/business/share_options'
import CommonImg from '@/components/views/common_img'
import ListLoading from '@/components/views/loading'

import LocalData from '@/utils/local_data'
import { App_User } from '@/data/user_info'

import { UserLog, sendCtmEvtLog } from '@/utils/log'
import { handleBuidingBanner } from '@/common/utils/map_view_data'

import BuildingTopTab from './_components/_building_top_tab'
import TopSwiper from './_components/_swiper'
import TopHeader from './_components/_top_header'
import TopTabs from './_components/_top_tabs'
import HouseTab from './_components/_house_tab'
import HouseContent from './_components/_content'
import HouseComments from './_components/_comments'
import YouLike from './_components/_you_like'
import BuildingFooter from './_components/_footer'


import BuildingEvent from './_components/_event'
import BusinessHeader from './_components/_business_header'
import PhoneTip from './_components/_phone_tip'


import { getInfoItems, initIconsData} from './utils'
import getShareText from './getShareText'

import getSubPage from './mixins/getSubPage'
import visit_reservation from './mixins/visit_reservation'
import consultant_footer from './mixins/consultant_footer'
import vr_video_source from './mixins/vr_video_source'

import TopTools from './_components/_top_tools'
import go_icon_location from './mixins/go_icon_location'
import web_720 from './mixins/web_720'
import get_userinfo from './mixins/getUserInfo'

import BuildingCompare from '@/data/building_compare'

const DEFAULT_DATA = {
    layout_image_exists: true,
    details: true,
    around_facility_exists: true,
    common_image_exists: true
}

const getDefaultTabs = (item = DEFAULT_DATA) => {
    return [
        {
            name: '户型图',
            type: 'layout',
            class: 'apartment-img',
            show: item.layout_image_exists
        },
        {
            name: '楼盘动态',
            type: 'events',
            class: 'events',
            show: true
        },
        {
            name: '楼盘详情',
            type: 'detail',
            show: Boolean(item.details)
        },
        {
            name: '周边配套',
            type: 'around',
            show: item.around_facility_exists
        },
        {
            name: '楼盘图片',
            type: 'common',
            class: 'house-img',
            show: item.common_image_exists
        }
    ]
}

const getDefaultEvents = () => {
    return {
        items: [],
        customer_service_info: {},
        is_consultant: false,
        building_event_author: false,
        total_count: 0,
        loading: true
    }
}

export default {
    mixins: [
        getSubPage,
        vr_video_source,
        go_icon_location,
        web_720,
    ],
    data () {
        return {
            icons: [],
            show_billboard: false,
            show_share_option: false,
            house: {
                view_count: '',
                current_houses: []
            },
            loading: true,
            tabs: getDefaultTabs(),
            current_house: {
                attachment_urls: {}
            },
            excellent_consultants: [],
            events: getDefaultEvents(),
            is_default_consultants: false,
            you_like_buidings: {},
            building_tabs: [],
            history_lot_houses: [],
            is_opened: false,
            show_result: false,
            show_article: false
        }
    },
    computed: {
        is_selling () {
            const { house_id } = this.$route.query
            console.error(house_id, this.house.status)
            return !house_id && this.house.status === '在售'
        },
        open_type () {
            return this.is_consultant ? '' : 'share'
        }
    },
    mounted () {
        this.checkSubPage()
        this.getMyConsultant()
        Service.init().then(() => {
            this.getData()
            const { building_id, scene_params } = this.$route.query
            UserLog.viewBuilding(building_id, scene_params || '')
        })
    },
    methods: {
        getMyConsultant () {
            Service.getMyConsultant().then(data => {
                this.consultant = data
            })
        },
        getYouLike () {
            if (this.house.vip_type === '尊享版') {
                return
            }
            const { building_id } = this.$route.query
            BuildingService.getYouLike(building_id).then((data) => {
                this.you_like_buidings = data
            })
        },
        goCall () {
            this.$showCallModal(this.getPhoneCall, '楼盘详情页——电话拨打')
        },
        getPhoneCall () {
            PublicService.getPhonePosition({
                building_id: this.house.id
            }).then(({ phone }) => {
                this.$wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
        showShareOption () {
            if (this.is_consultant) {
                this.show_share_option = true
            }
        },
        hideShareOption () {
            this.show_share_option = false
        },
        toggleBillboard () {
            this.show_billboard = !this.show_billboard
        },
        getData () {
            this.loading = true
            const { house_id, building_id, from, scene_params, share_by_consultant_uid } = this.$route.query
            const params = {
                house_id: house_id || '',
                share_by_consultant_uid: App_User.share_by_consultant_uid || share_by_consultant_uid || scene_params || ''
            }
            BusinessBuildingService.get(building_id, params).then(data => {
                data.photos_urls = data.photos_urls.map((item) => handleBuidingBanner(item))
                data.favourite = data.follow_info && data.follow_info.id

                this.tabs = getDefaultTabs(data)
                this.icons = initIconsData(data)

                const { details } = data
                const items = getInfoItems('商业')
                data.house_info = items.reduce((prev, key) => {
                    if (details && details[key]) {
                        prev.push({
                            key,
                            value: details[key]
                        })
                    }
                    return prev
                }, [])

                data.longitude = data.location ? data.location.split(',')[0] : ''
                data.latitude = data.location ? data.location.split(',')[1] : ''

                data.view_count = data.view_count >= 10000 ? `${(data.view_count / 10000).toFixed(1)}w` : data.view_count
                this.house = data
                this.loading = false
                this.getUser(building_id)
                this.$refs.house_comments.getData(this.house.id)
                setTimeout(this.getOtherInfo)
            }).catch(err => {
                console.error(err)
                if (err === 404) {
                    wx.switchTab({
                        url: '/pages/index/main'
                    })
                }
            })
        },
        getOtherInfo () {
            this.getEvents()
            this.getYouLike()
        },
        getExcellentConsultant (building_id) {
            BuildingService.excellentConsultants(building_id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        },
        getEvents () {
            const { building_id } = this.$route.query
            BuildingService.getEvent(building_id, {
                page: 1,
                per: 1
            }).then((data) => {
                this.events = {
                    items: data.items && data.items.length ? data.items.slice(0, 1) : [],
                    is_consultant: data.is_consultant,
                    building_event_author: data.building_event_author,
                    customer_service_info: {},
                    total_count: data.total_count,
                    loading: false
                }
                this.$set(this.tabs, 1, {
                    ...this.tabs[1],
                    show: Boolean(data.total_count)
                })
                App_User.customer_service_info().then((customer_service_info) => {
                    this.events.customer_service_info = customer_service_info
                })
            })
        },
        getUser () {
            LocalData.user.get().then(data => {
                this.is_consultant = data.is_consultant
            })
        },
        openMap () {
            const { latitude, longitude, name, address } = this.house
            if (latitude && longitude) {
                wx.openLocation({
                    latitude: Number(latitude),
                    longitude: Number(longitude),
                    name,
                    address
                })
            }
        },
        goAddComments () {
            const { name, id } = this.house
            this.$router.push({
                path:`/building/comments/add?building_id=${id || ''}&name=${name}`
            })
        },
        goTab (e) {
            const { type, name, index } = e.currentTarget.dataset
            if (!this.tabs[index].show) {
                return
            }
            if (type === 'common' || type === 'layout') {
                this.goPreview(type, name)
            } else if (type === 'events') {
                this.goEvent()
            } else if (type === 'around') {
                this.goAround('metro')
            } else {
                this.goHouseInfo(type)
            }
        },
        goHouseInfo (type = 'detail') {
            const { id, building_id } = this.$route.query
            this.goSubPagePath(`/building/info?type=${type}&id=${id}&building_id=${building_id || ''}`)
        },
        goPreview (type, name) {
            if (this.loading) {
                return
            }
            const { building_id } = this.$route.query
            const title = `${this.house.name}-${name}`
            let house_id = this.house.current_houses.map(({ id }) => id).join(',')
            if (type === 'price') {
                house_id = this.current_house.id
            }
            this.goSubPagePath(`/building/img_preview?house_id=${house_id || ''}&type=${type}&title=${title}&building_id=${building_id || ''}`)
        },
        goAround (category = '') {
            this.goSubPagePath(`/building/around_facilities/map?id=${this.house.id}&type=business&category=${category}`)
        },
        goComments () {
            console.log(212312)
            this.goSubPagePath(`/building/comments?building_id=${this.house.id || ''}&name=${this.house.name}`)
        },
        goConsultant () {
            const { consultant_group_id } = this.$route.query
            this.goSubPagePath(`/consultants/filter/main?id=${this.house.id}&consultant_group_id=${consultant_group_id || ''}&from=楼盘详情`)
        },
        goBuildingArticle () {
            const { building_id } = this.$route.query
            this.goSubPagePath(`/building/article/main?building_id=${building_id}`)
        },
        goEvent () {
            const { building_id } = this.$route.query
            this.goSubPagePath(`/building/event?building_id=${building_id}`)
        },
        tabLog (e) {
            const { name: eventName } = e.currentTarget.dataset
            sendCtmEvtLog('楼盘详情页——' + eventName)
        }
    },
    components: {
        CommonImg,
        ListLoading,

        BuildingTopTab,
        TopSwiper,
        TopHeader,
        HouseTab,
        TopTabs,
        HouseContent,
        HouseComments,

        YouLike,

        BuildingFooter,

        BuildingEvent,

        BusinessHeader,
        PhoneTip,
        TopTools,
    }
}
